// extracted by mini-css-extract-plugin
export var container = "_5s-1";
export var editor = "_5s-2";
export var resizable = "_5s-3";
export var wrapper = "_5s-0";